import React, { Suspense, lazy, useEffect, useState } from "react";
import FilterBlock from "../../components/FilterBlock";
import useGymsData from "../../hooks/useGymsData";
import Loader from "../../components/ui/Loader";
import LightTable from "../../components/components-bootstrap/LightTable";
import { useGetFetch, useUpdateFetch } from "../../data/Queries";
import {
  memberDelete,
  memberGet,
  memberGetKey,
} from "../../data/ApiEndpoints";
import { useSelector } from "react-redux";
import { selectAuth, selectToken } from "../../components/auth/auth.selector";
import PaginationLight from "../../components/components-bootstrap/PaginationLight";
import { formatDate } from "../../utils/utilityfunc";
import Icons from "../../components/ui/Icons";
import ReactModal from "react-modal";
import ModalHeader from "../../components/ModalHeader";
import { toast } from "react-toastify";
import MemberDetails from "./MemberDetails";
import { CSVLink } from "react-csv";
import { getDataApi } from "../../data/axios";
import { BASE_URL } from "../../data/BaseUrl";
import {
  convertStraight,
  formatDateTimezon,
} from "../../components/common-data/Converts";
import { daysAgo } from "../../components/common-data/DropdowData";
import SelectExportables from "../../components/common-components/SelectExportables";
import HelmetWrapper from "../../HelmetWrapper";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";
import MemberImportModal from "../../components/member/MemberImportModal";

const MemberForm = lazy(() => import("../../components/member/MemberForm"));

const MemberPage = () => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};
  const isAdmin = user?.account_type === "admin";
  const isMarketing = user?.account_type === "marketing";
  const isClusterManager = user?.account_type === "cluster_manager";

  //   const [filters, setFilters] = useState();
  const [dateFilter, setDateFilter] = useState();
  const [csvData, setCsvData] = useState("");
  const [isLoadingCSV, setIsLoadingCSV] = useState(false);
  const [memberDetailsModal, setMemberDetailsModal] = useState({
    status: false,
    data: null,
  });
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState({ status: false, data: null });
  const [importModal, setImportModal] = useState(false);
  const token = useSelector(selectToken);

  const [exportModal, setExportModal] = useState(false);
  const exportableData = [
    "name",
    "mobile",
    "email",
    "subscription_status",
    "last_login",
    "last_checkin_days_ago",
    "status",
    "date_added",
    "is_completed",
  ];

  const {
    data: gymsData,
    isLoading: isLoadingGyms,
    isFetching: isFetchingGyms,
  } = useGymsData();

  // MEMBERS DATA
  const [memberFilters, setMemberFilters] = useState({
    limit: "10",
    gym_id:
      !isAdmin && !isMarketing && !isClusterManager
        ? user?.gym_id || user?.uid || user?.user_id
        : "",
  });
  const [isPage, setIsPage] = useState(0);
  const {
    data: membersData,
    isLoading: isLoadingMembersData,
    isFetching: isFetchingMembersData,
    refetch: refetchMembersData,
  } = useGetFetch({
    url: memberGet,
    key: memberGetKey,
    filters: memberFilters,
    isPage: isPage + 1,
    token,
  });

  const { mutateAsync: deleteMember, isLoading: isLoadingMD } = useUpdateFetch({
    token,
    url: memberDelete,
    key: memberGetKey,
  });

  const registeredFromOptions = [
    { label: "App", value: "app" },
    { label: "Web", value: "web" },
  ];

  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ];

  async function fetchCSVData(memberFilters, fields) {
    let endPoint = `${BASE_URL}${memberGet}?page=1&limit=10&is_export=1${
      fields ? "&" + fields : ""
    }`;

    if (memberFilters) {
      for (const key in memberFilters) {
        if (key && memberFilters[key]) {
          endPoint += `&${key}=${memberFilters[key]}`;
        }
      }
    }

    try {
      setIsLoadingCSV(true);
      const data = await getDataApi({
        url: `${endPoint}`,
        token,
      });

      if (data) {
        setCsvData(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingCSV(false);
    }
  }

  const allFilters = [
    {
      id: 0,
      label: "Gym",
      name: "gym_id",
      options: [...gymsData, { label: "NA", value: "na" }],
    },
    {
      id: 1,
      label: "Registered From",
      name: "download_status",
      options: registeredFromOptions,
    },
    {
      id: 2,
      label: "Status",
      name: "status",
      options: statusOptions,
    },
    {
      id: 3,
      label: "Subscription Status",
      name: "subscription_status",
      options: statusOptions,
    },
    {
      id: 4,
      label: "Last Checkin Day",
      name: "last_checkin_days_ago",
      options: daysAgo,
    },
  ];

  function handleChange(date) {
    try {
      setDateFilter(date);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleMemberDelete(uid) {
    try {
      if (window.confirm("Do you really want to delete this member ?")) {
        const { status, message } = await deleteMember({ data: { uid } });

        if (status) {
          toast.success(message ? message : "Success!");
        } else {
          toast.error(message ? message : "Server Error!");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function fetching() {
    try {
      if (isLoadingGyms || isFetchingGyms) {
        return true;
      }

      if (isLoadingMembersData || isFetchingMembersData) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      fetchCSVData(memberFilters);
    } catch (error) {
      console.log(error);
    }
  }, [memberFilters]);

  useEffect(() => {
    try {
      refetchMembersData();
    } catch (error) {
      console.log(error);
    }
  }, [isPage, memberFilters]);

  useEffect(() => {
    if (!isAdmin && !isMarketing && !isClusterManager) {
      setMemberFilters((prevs) => ({
        ...prevs,
        gym_id: user?.gym_id || user?.uid || user?.user_id || "",
      }));
    }
  }, [user?.gym_id, isAdmin, isMarketing, isClusterManager]);

  const memberDataCols = [
    {
      dataField: "",
      text: "Member Details/Fitness Profile",
      formatter: (_, row) => {
        const name = row?.name;
        const email = row?.email;
        const mobile = row?.mobile;
        return (
          <div className="flex-k flex-col-k items-start-k fs-small-k bold-text">
            <span
              onClick={() => setMemberDetailsModal({ status: true, data: row })}
              className="table-link-k"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                columnGap: "5px",
                textTransform: "capitalize",
              }}
            >
              {row?.is_completed === 1 ? (
                <CheckCircleIcon />
              ) : (
                <CrossCircleIcon />
              )}
              {name}
            </span>
            <span>{email}</span>
            <span>{mobile}</span>
          </div>
        );
      },
    },
    {
      dataField: "subscriptions",
      text: "Gym",
      formatter: (data) => {
        const gym = data && data?.length && data[0]?.gym_name;
        return <span className="flex-k fs-small-k">{gym || "N/A"}</span>;
      },
    },
    {
      dataField: "subscriptions",
      text: "Trainer",
      formatter: (data) => {
        const trainer = data && data?.length && data[0]?.trainer_name;
        return <span className="flex-k fs-small-k">{trainer || "N/A"}</span>;
      },
    },
    {
      dataField: "age",
      text: "Age",
      formatter: (data) => {
        return <span className="flex-k fs-small-k">{data || "N/A"}</span>;
      },
    },
    {
      dataField: "gender",
      text: "Gender",
      formatter: (data) => {
        return (
          <span className="flex-k capitalise-k fs-small-k">
            {data || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "diet_category_name",
      text: "Diet Category",
      formatter: (data) => {
        return <span className="flex-k fs-small-k">{data || "N/A"}</span>;
      },
    },
    {
      dataField: "subscriptions",
      text: "Plan",
      formatter: (data) => {
        const type =
          data && data?.length && `${data[0]?.type}`?.replaceAll("_", " ");
        return (
          <span className="flex-k capitalise-k fs-small-k">
            {type || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Last Checkin",
      formatter: (data) => {
        return (
          <span className="flex-k fs-small-k min-wid-90">
            {data ? convertStraight(data) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "last_login",
      text: "Last Login",
      formatter: (data) => {
        return (
          <span className="flex-k fs-small-k min-wid-90">
            {data ? formatDate(Number(data) * 1000) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "created_on",
      text: "Created On",
      formatter: (data) => {
        return (
          <span className="flex-k fs-small-k min-wid-90">
            {data ? formatDateTimezon(data) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (data) => {
        return (
          <span className="flex-k fs-small-k min-wid-90">
            {data ? formatDate(Number(data)) : "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (data) => {
        const isSub = data === "active";
        return (
          <div className="flex-k js-start-k">
            <p
              className={`fs-small-k w-6rem-k word-wrap-k capitalise-k highlighted ${
                !isSub ? "red" : "green"
              }`}
            >
              {data || "N/A"}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "Subscription",
      formatter: (data) => {
        const isSub = data === "No Active Subscription Found";
        return (
          <div className="flex-k js-start-k">
            <p
              className={`fs-small-k w-6rem-k word-wrap-k capitalise-k highlighted ${
                isSub ? "red" : "green"
              }`}
            >
              {data || "N/A"}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="flex-k gap-05-k js-center-k items-center-k">
            <button
              onClick={() => setEditModal({ status: true, data: row })}
              disabled={isLoadingMD}
              className="btn-k btn-muted-k small"
            >
              <Icons size="25" name={"edit"} />
            </button>
            <button
              onClick={() => handleMemberDelete(row?.uid)}
              className="btn-k btn-muted-k small"
            >
              <Icons size="25" name={"delete"} />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Member Management">
      <section className="cloud-bg-k">
        <div className="container-k p-1">
          <header className="flex-k items-center-k js-between-k my-1">
            <h4 className="bold-text fs-med-k">Members</h4>

            <div className="flex-k items-center-k gap-1-k">
              <button
                onClick={() => setAddModal(true)}
                className="btn-k dark-bg-k"
              >
                Add Member
              </button>

              <div className="flex-k items-center-k gap-1-k">
                <button
                  onClick={() => setImportModal(true)}
                  className="btn-k dark-bg-k"
                >
                  Import Member
                </button>
              </div>
              {/* {isLoadingCSV ? (
                <button
                  disabled={isLoadingCSV}
                  className="btn-k dark-bg-k flex-k items-center-k js-center-k gap-05-k"
                >
                  <span className="text-white">Fetching...</span>
                  <Loader size={"small"} color="#ffffff" />
                </button>
              ) : (
                <CSVLink
                  download={"members_data.csv"}
                  className="btn-k dark-bg-k decoration-none-k"
                  data={csvData}
                >
                  Export CSV
                </CSVLink>
              )} */}

              <button
                onClick={() => setExportModal(true)}
                className="btn-k dark-bg-k"
              >
                Choose To Export
              </button>
            </div>
          </header>

          <FilterBlock
            isSearch={{ placeholder: "Search By Name.." }}
            isDate={{ key: "date_added", dateFilter, handleChange }}
            setFilters={(filters) => {
              setIsPage(0);
              setMemberFilters({
                ...filters,
                limit: "10",
                date_added: filters ? dateFilter : "",
              });
            }}
            allFilters={allFilters}
          />

          {fetching() ? (
            <div className="flex-k js-center-k items-center-k my-6-k">
              <Loader />
            </div>
          ) : (
            <div className="py-2">
              <LightTable
                columns={memberDataCols}
                data={membersData?.data || []}
              />
              <PaginationLight
                isPage={isPage}
                onChangePage={setIsPage}
                pagination={membersData?.pagination || []}
              />
            </div>
          )}
        </div>

        <ReactModal ariaHideApp={false} isOpen={exportModal}>
          <div className="modal-body-k small rounded-5 bg-white">
            <ModalHeader
              title={"Select Fields To Export"}
              onClick={() => setExportModal(false)}
            />
            <div>
              <SelectExportables
                name={"members"}
                exportableData={exportableData}
                filters={memberFilters}
                callFunction={fetchCSVData}
                isLoadingCSV={isLoadingCSV}
                csvData={csvData}
              />
            </div>
          </div>
        </ReactModal>

        <ReactModal
          ariaHideApp={false}
          isOpen={editModal?.status}
          onRequestClose={() => setEditModal({ status: false, data: null })}
        >
          <Suspense fallback={<Loader />}>
            <div className="modal-body-k bg-white rounded-5">
              <ModalHeader
                title={"Edit Member"}
                onClick={() => setEditModal({ status: false, data: null })}
              />
              <MemberForm
                data={editModal?.data}
                onClose={() => setEditModal({ status: false, data: null })}
              />
            </div>
          </Suspense>
        </ReactModal>

        <ReactModal
          ariaHideApp={false}
          isOpen={addModal}
          onRequestClose={() => setAddModal(false)}
        >
          <Suspense fallback={<Loader />}>
            <div className="modal-body-k bg-white rounded-5">
              <ModalHeader
                title={"Add Member"}
                onClick={() => setAddModal(false)}
              />
              <MemberForm onClose={() => setAddModal(false)} />
            </div>
          </Suspense>
        </ReactModal>

        <ReactModal
          ariaHideApp={false}
          onRequestClose={() =>
            setMemberDetailsModal({ status: false, data: null })
          }
          isOpen={memberDetailsModal?.status}
        >
          <div className="modal-body-k large cloud-bg-k rounded-5">
            <ModalHeader
              title={"View Member Details"}
              onClick={() =>
                setMemberDetailsModal({ status: false, data: null })
              }
            />

            <Suspense fallback={<Loader />}>
              <MemberDetails
                memberDetail={memberDetailsModal?.data}
                refetchMembersData={refetchMembersData}
                isLoadingMember={isLoadingMembersData || isFetchingMembersData}
                onClose={() =>
                  setMemberDetailsModal({ status: false, data: null })
                }
              />
            </Suspense>
          </div>
        </ReactModal>

        <MemberImportModal
          isOpen={importModal}
          onClose={() => setImportModal(false)}
          userInfoData={{ ...user, token }}
          onImportSuccess={refetchMembersData}
        />
      </section>
    </HelmetWrapper>
  );
};

export default MemberPage;
